import { render } from "./AddressList.vue?vue&type=template&id=44cd58c8&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=44cd58c8&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cd58c8"]])

export default __exports__